/* eslint-disable no-useless-escape */
import { compareDates } from '../../../utils/date-utils';
import { getFormattedIntegerValues } from '../../../utils/number-utils';
import { isEmpty } from '../../../utils/object-utils';

const SHOW_LATEST_DATA = 'showLatestData';
const DATE_TO_FILTER_BY = 'dateToFilterBy';
const FROM_DATE = 'from';
const TO_DATE = 'to';

export function setShowLatestData(showLatestData) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has(SHOW_LATEST_DATA)) {
        urlParams.delete(SHOW_LATEST_DATA);
    }

    urlParams.append(SHOW_LATEST_DATA, showLatestData);

    window.history.replaceState(
        null,
        'Show Latest Data',
        `?${urlParams.toString()}`
    );
}

export function getShowLatestData() {
    const urlParams = new URLSearchParams(window.location.search);
    const dateToFilterBy = getDateToFilterByParameter();
    const dateRange = getDateRangeParameters();

    if (!urlParams.has(SHOW_LATEST_DATA)) {
        return dateToFilterBy === '' && isEmpty(dateRange);
    }

    const showLatestData = urlParams.get(SHOW_LATEST_DATA);
    return showLatestData === 'true';
}

export function removeShowLatestData() {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has(SHOW_LATEST_DATA)) {
        return;
    }

    urlParams.delete(SHOW_LATEST_DATA);

    window.history.replaceState(
        null,
        'Show Latest Data',
        `?${urlParams.toString()}`
    );
}

export function setDateToFilterBy(dateToFilterBy) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has(DATE_TO_FILTER_BY)) {
        urlParams.delete(DATE_TO_FILTER_BY);
    }

    urlParams.append(DATE_TO_FILTER_BY, dateToFilterBy);

    window.history.replaceState(
        null,
        'Sorted Analytics Data',
        `?${urlParams.toString()}`
    );
}

export function getDateToFilterByParameter() {
    const urlParams = new URLSearchParams(window.location.search);

    if (!urlParams.has(DATE_TO_FILTER_BY)) {
        return '';
    }

    const dateAsTime = urlParams.get(DATE_TO_FILTER_BY);
    return new Date(getFormattedIntegerValues(dateAsTime));
}

export function removeDateToFilterBy() {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has(DATE_TO_FILTER_BY)) {
        return;
    }

    urlParams.delete(DATE_TO_FILTER_BY);

    window.history.replaceState(
        null,
        'Sorted Analytics Data',
        `?${urlParams.toString()}`
    );
}

export function setDateRangeFilters(dateRange) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has(FROM_DATE)) {
        urlParams.delete(FROM_DATE);
    }

    if (urlParams.has(TO_DATE)) {
        urlParams.delete(TO_DATE);
    }

    urlParams.append(FROM_DATE, dateRange.from);
    urlParams.append(TO_DATE, dateRange.to);

    window.history.replaceState(
        null,
        'Sorted Analytics Data',
        `?${urlParams.toString()}`
    );
}

export function getDateRangeParameters() {
    const urlParams = new URLSearchParams(window.location.search);

    if (!urlParams.has(FROM_DATE) || !urlParams.has(TO_DATE)) {
        return [];
    }

    const fromUrlParameters = urlParams.get(FROM_DATE);
    const toUrlParameter = urlParams.get(TO_DATE);

    if (isEmpty(fromUrlParameters) || isEmpty(toUrlParameter)) {
        return [];
    }

    const formAsDate = new Date(getFormattedIntegerValues(fromUrlParameters));
    const toAsDate = new Date(getFormattedIntegerValues(toUrlParameter));

    const dateComparisonResult = compareDates(formAsDate, toAsDate);

    if (dateComparisonResult === 1) {
        return [];
    }

    return {
        from: formAsDate,
        to: toAsDate
    };
}

export function removeDateRangeFilters() {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has(FROM_DATE) || !urlParams.has(TO_DATE)) {
        return;
    }

    urlParams.delete(TO_DATE);
    urlParams.delete(FROM_DATE);

    window.history.replaceState(
        null,
        'Sorted Analytics Data',
        `?${urlParams.toString()}`
    );
}

export function shortUrlFormat(accessedUrl) {
    const formattedUrl = accessedUrl.replace(/^.*\/\/[^\/]+/, '');
    return formattedUrl === '/' ? accessedUrl : formattedUrl;
}
